(function () {
    'use strict';

    angular.module("imApp").factory("travelBillLogsService", ['$ihttp', function ($ihttp) {
        let service = {
            listLogs: function (parms) {
                return $ihttp.post({
                    method: 1623,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
